import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Navbar from "./Navbar";

import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllLectures, getDailyUserLectures } from "../Redux/LectureReducer/action";
import { convertDate } from "../Services/index";
import { convertTimeFormat } from "../Services/index";
import {
  deleteBookMark,
  getBookmarks,
  setBookMark,
} from "../Redux/BookmarkReducer/action";
import {
  REMOVE_BOOKMARK_SUCCESS,
  SET_BOOKMARK_SUCCESS,
} from "../Redux/BookmarkReducer/actionTypes";
import MDEditor from "@uiw/react-md-editor";
import moment from "moment";
import { formatTime } from "../utils";
import { Loader } from "./Loader";
const AboutLecture = () => {
  const { id } = useParams();
  const [currentLecture, setCurrentLecture] = useState({});
  const [bookmarkStatus, setBookmarkStatus] = useState(false);
  const lectures = useSelector((state) => state.LectureReducer.lectures);
  const loading = useSelector((state) => state.LectureReducer.isLoading);
  const user = useSelector((state) => state.AuthReducer.user);
  const token = useSelector((state) => state.AuthReducer.token);
  const dispatch = useDispatch();
  const bookmarks = useSelector((state) => state.BookmarkReducer.bookmarks);
  const batchId = user.batchId;
  const sectionId = user.sectionId;
  const userId = user.id;
  const role = user.roles[0].name;
  const lectureId = currentLecture.lectureId;
  const name = user.name;

  useEffect(() => {
    if (bookmarks?.length === 0) {
      dispatch(getBookmarks(userId, token));
    }
  }, [dispatch, bookmarks.length]);
  useEffect(() => {
    if (lectures?.length == 0) {
      dispatch(getAllLectures(batchId, sectionId, token));
    }
  }, [dispatch, lectures.length]);

  useEffect(() => {
    const currentLec = lectures.find((item) => item.lectureId === Number(id));
    currentLec && setCurrentLecture(currentLec);
  }, [id, lectures, setCurrentLecture]);

  const handleAddBookmark = (e) => {
    e.preventDefault();
    console.log("bookmark function");
    if (userId && lectureId && token) {
      dispatch(setBookMark(userId, lectureId, token)).then((r) => {
        if (r === SET_BOOKMARK_SUCCESS) {
          console.log("bookmarkSaved");
          setBookmarkStatus(true);
        }
      });
    }
  };

  const handleRemoveBookmark = (e) => {
    e.preventDefault();
    console.log("deletebookmark");
    if (userId && lectureId && token) {
      dispatch(deleteBookMark(userId, lectureId, token)).then((r) => {
        if (r === REMOVE_BOOKMARK_SUCCESS) {
          console.log("bookmark deleted");
          setBookmarkStatus(false);
        }
      });
    }
  };

  useEffect(() => {
    if (id) {
      const currentBookmark =
        bookmarks.length > 0 &&
        bookmarks.find((item) => item.lectureId === Number(id));
      currentBookmark && setBookmarkStatus(true);
    }
  }, [lectureId, setBookmarkStatus]);
  console.log("currentLecture", currentLecture);

  console.log("bookmar aboute", bookmarks);
  let currentTime = 0;
  let scheduledTime = 0;
  if (currentLecture.concludeTime) {
    const mls = moment(formatTime(currentLecture.concludeTime));
    scheduledTime = mls.valueOf();
    const dt = new Date();
    currentTime = Date.parse(dt);
  }

  return (
    <div>
      <Navbar name={name} role={role} />
      <header className="bg-white shadow">
        <div className="w-[100%] mx-auto py-4 px-6 sm:px-6 lg:px-16">
          <div className="py-2  inline-flex float-right text-left px-16">
            <form>
              <input type="hidden" />
              <input type="hidden" />

              {bookmarkStatus ? (
                <button
                  onClick={handleRemoveBookmark}
                  className="inline-flex items-center px-4 py-2 border border-black-600 shadow-sm text-[16px] font-medium rounded-md text-black-400 bg-white hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-100"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="-ml-1 mr-1 h-4 w-5"
                    viewBox="0 0 20 20"
                  >
                    <path d="M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z"></path>
                  </svg>
                  Remove Bookmark
                </button>
              ) : (
                <button
                  className="inline-flex items-center px-4 py-2 border border-black-600 shadow-sm font-medium rounded-md text-black-400 bg-white hover:bg-gray-100 focus:outline-none focus:ring-2 focus-ring-offset-2  focus:ring-gray-100"
                  onClick={handleAddBookmark}
                >
                  <svg
                    className="-ml-1 mr-1 h-4 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"></path>
                  </svg>
                  Bookmark
                </button>
              )}
            </form>
          </div>
          {Object.keys(currentLecture).length === 0 ? (
            ""
          ) : (
            <div>
              <h2 className="font-semibold text-left text-xl text-gray-800 leading-tight ml-8">
                {currentLecture.title}

                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800 uppercase mr-2">
                  {currentLecture.category}
                </span>
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800 uppercase">
                  {currentLecture.type}
                </span>
              </h2>
              <h3 className="font-semibold ml-8 text-sm text-left text-gray-600 leading-tight uppercase mt-1">
                {currentLecture
                  ? `${currentLecture.createdBy} ${convertDate(
                    currentLecture.startTime
                  )} ${convertTimeFormat(currentLecture.startTime)}`
                  : ""}
              </h3>
            </div>
          )}
        </div>
      </header>
      {Object.keys(currentLecture).length !== 0 &&
        currentLecture.type === "live" &&
        currentTime <= scheduledTime ? (
        <div className=" w-full border border-red-800 h-72 bg-[blue] pt-24">
          <p className="text-sm text-white ">
            Make your microphone mute when joining a meeting
          </p>
          <Link
            to={
              "https://support.zoom.us/hc/en-us/articles/203024649-Muting-your-microphone-when-joining-a-meeting"
            }
          >
            <p className="text-white text-sm mt-[10px] underline">
              Automatic Zoom Mute Setting
            </p>
          </Link>
          <Link to={currentLecture.zoomLink}>
            <button className="py-2 px-4 bg-white rounded-md mt-[20px] ">
              Zoom Meeting
            </button>
          </Link>
        </div>
      ) : (
        ""
      )}

      <main>
        <div className="py-12 bg-[#f3f4f6]">
          {loading ? <Loader /> : ""}
          <div className="max-w-6xl mx-auto sm:px-6 lg:px-8  px-8">
            <div className="bg-white shadow overflow-hidden sm:rounded-md py-4 px-4 ">
              <div className="mb-4">
                <nav className="relative z-0 rounded-lg shadow flex divide-x divide-gary-200 ">
                  <a
                    href="#"
                    className="text-gray-900 rounded-l-lg group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10 border-b hover:border-indigo-600 active:border-indigo-600 "
                  >
                    <span>Details</span>
                    <span className="bg-indigo-500 hover:absolute inset-x-0 bottom-0 h-0.5"></span>
                  </a>
                  <a
                    href="#"
                    className="text-gray-900 rounded-l-lg group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10  border-b hover:border-indigo-600 active:border-indigo-600 "
                  >
                    <span>Discussions</span>
                  </a>
                </nav>
              </div>
              {currentLecture.hideVideo == false ? <div>
                <h2 className="font-semibold text-xl text-indigo-600 leading-tight uppercase text-center">
                  Lecture Video
                </h2>
                <div className="py-4 max-w-3xl mx-auto">
                  <video
                    src={currentLecture.video}
                    type="video/mp4"
                    controls
                    preload="none"
                    className="w-full"
                  ></video>
                </div>


              </div> : ""}
              {currentLecture.notes ? <div>
                <h2 className="font-semibold text-xl text-indigo-600 leading-tight mt-[15px] uppercase text-center">
                  Notes
                </h2>
                <div className="py-4 max-w-3xl mx-auto">
                  <MDEditor.Markdown source={currentLecture.notes} />
                </div>
              </div> : ""}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutLecture;
